import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Rating, useTheme, useMediaQuery } from "@mui/material";
import { FormatQuote, Smartphone, TabletMac, Headphones, Star } from "@mui/icons-material";
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";

interface Review {
    id: number | string;
    name: string;
    device: string;
    deviceType: 'phone' | 'tablet' | 'airpods';
    rating: number;
    text: string;
    date: string;
}

const defaultReviews: Review[] = [
    { id: 1, name: "김**", device: "갤럭시 S24 울트라 512GB", deviceType: 'phone', rating: 5, text: "시세 조회했을 때 가격이 제일 높아서 신청했는데, 실제 입금액도 동일했습니다. 검수도 빠르고 입금까지 하루 만에 완료! 다음에도 무조건 여기서 매입할 예정입니다.", date: "2026.03" },
    { id: 2, name: "이**", device: "아이폰 15 Pro Max 256GB", deviceType: 'phone', rating: 5, text: "새 폰으로 바꾸면서 기존 폰 매입했어요. 블랑코 데이터 삭제 인증서도 받아서 개인정보 걱정 없이 안심하고 거래했습니다. 가격도 매우 만족스럽습니다.", date: "2026.03" },
    { id: 3, name: "박**", device: "갤럭시 탭 S9+ Wi-Fi 512GB", deviceType: 'tablet', rating: 5, text: "좀 예전 모델이라서 걱정했는데 잘 보관한 보람이 있네요!!! 생각보다 좋은 가격이 나왔습니다. 처리도 엄청 빠르게 해주시고 신뢰가 갑니다.", date: "2026.02" },
    { id: 4, name: "최**", device: "에어팟 프로 2세대", deviceType: 'airpods', rating: 5, text: "보관만 하고 있다가 매입할 수 있는 곳을 알게 되어서 잘 처분했네요. 친절하고 빠르게 처리해 주셨고 가격도 만족스럽습니다. 다음에 또 이용하겠습니다!", date: "2026.02" },
    { id: 5, name: "정**", device: "갤럭시 노트 20 울트라 512GB", deviceType: 'phone', rating: 5, text: "집에 굴러다니는 공기계라 아무 생각없이 그냥 처분하려고 했는데 생각지도 못한 가격으로 매입해 주셔서 기분 좋네요. 검수도 빨랐고 합리적인 가격입니다.", date: "2026.02" },
    { id: 6, name: "윤**", device: "아이패드 프로 12.9 6세대 256GB", deviceType: 'tablet', rating: 5, text: "새 아이패드 구매하면서 기존 것 매입 진행했습니다. 택배 보내고 이틀 만에 검수 완료, 바로 입금! 이렇게 빠를 줄 몰랐어요. 강력 추천합니다.", date: "2026.01" },
    { id: 7, name: "한**", device: "갤럭시 Z 플립 5 256GB", deviceType: 'phone', rating: 4, text: "폴더블폰이라 매입가가 낮을 줄 알았는데 생각보다 좋은 가격에 매입해주셨습니다. 등급 기준도 명확하게 안내해주셔서 투명한 거래였습니다.", date: "2026.01" },
    { id: 8, name: "오**", device: "아이폰 14 128GB", deviceType: 'phone', rating: 5, text: "중고나라에 올리려다가 여기서 시세 조회해보니 비슷한 가격이라 안전하게 매입 맡겼습니다. 사기 걱정 없이 깔끔하게 거래할 수 있어서 좋았어요.", date: "2026.01" },
    { id: 9, name: "신**", device: "갤럭시 S23 256GB", deviceType: 'phone', rating: 5, text: "방문수거 서비스가 정말 편리합니다. 택배 기사님이 직접 와서 수거해가시고, 검수 후 바로 입금! 회사에서 업무 중에도 처리할 수 있어서 너무 좋았어요.", date: "2025.12" },
    { id: 10, name: "강**", device: "에어팟 맥스 실버", deviceType: 'airpods', rating: 5, text: "잘 사용하지 않던 에어팟 맥스를 매입했는데 상태 좋다고 A등급 받았습니다. 예상보다 높은 금액에 매입되어서 정말 만족합니다. 감사합니다!", date: "2025.12" },
    { id: 11, name: "임**", device: "갤럭시 탭 S8 울트라 128GB", deviceType: 'tablet', rating: 5, text: "서랍에 넣어두고 안 쓰던 태블릿이었는데, 시세 조회해보니 아직 괜찮은 가격이라 바로 신청했어요. 후회 없는 선택이었습니다.", date: "2025.12" },
    { id: 12, name: "조**", device: "아이폰 13 Pro 256GB", deviceType: 'phone', rating: 5, text: "액정에 미세한 기스가 있어서 감가될 줄 알았는데, 등급 기준이 합리적이라 생각보다 좋은 가격 받았습니다. 데이터 삭제 인증서도 꼼꼼하게 발급해주셨어요.", date: "2025.11" },
    { id: 13, name: "양**", device: "아이패드 에어 5세대 64GB", deviceType: 'tablet', rating: 4, text: "용량이 작은 모델이라 매입가가 높진 않았지만, 타 업체보다는 확실히 좋은 조건이었습니다. 무엇보다 거래 과정이 매우 투명하고 빨라서 좋았어요.", date: "2025.11" },
    { id: 14, name: "배**", device: "갤럭시 Z 폴드 4 512GB", deviceType: 'phone', rating: 5, text: "폴드폰 매입가가 이렇게 좋은 줄 몰랐습니다. 다른 곳은 폴더블이라 감가가 심했는데, 여기는 상태 기준으로 공정하게 평가해주셔서 감사합니다.", date: "2025.11" },
    { id: 15, name: "노**", device: "에어팟 프로 2세대", deviceType: 'airpods', rating: 5, text: "에어팟도 매입이 되는지 몰랐는데, 시세 조회해보니 의외로 괜찮은 가격이라 바로 진행했습니다. 소소하지만 확실한 용돈벌이! 추천합니다.", date: "2025.10" },
    { id: 16, name: "서**", device: "아이폰 15 256GB", deviceType: 'phone', rating: 5, text: "16 시리즈 출시와 함께 기존 폰을 매입했어요. 출시 직전이라 시세가 떨어질까 걱정했는데 합리적인 가격에 매입해주셨습니다. 타이밍 상담도 해주셔서 감사해요.", date: "2025.10" },
    { id: 17, name: "문**", device: "갤럭시 탭 A8 64GB", deviceType: 'tablet', rating: 5, text: "보급형 태블릿이라 매입이 안 될 줄 알았는데 가능하더라고요! 금액이 크진 않지만 서랍에 묵히는 것보다 훨씬 나은 선택이었습니다.", date: "2025.10" },
    { id: 18, name: "류**", device: "갤럭시 S24+ 256GB", deviceType: 'phone', rating: 5, text: "최신 기종이라 매입가가 높을 거라 기대했는데 기대 이상이었습니다! 당일 검수, 당일 입금! 이 스피드가 가장 마음에 들었어요.", date: "2025.09" },
    { id: 19, name: "황**", device: "아이패드 미니 6세대 256GB", deviceType: 'tablet', rating: 4, text: "미니 모델 매입가도 나쁘지 않아서 만족합니다. 전체적으로 과정이 심플하고 불필요한 단계가 없어서 바쁜 사람에게 딱 맞는 서비스예요.", date: "2025.09" },
    { id: 20, name: "송**", device: "아이폰 14 Pro 512GB", deviceType: 'phone', rating: 5, text: "용량 큰 모델이라 매입가도 높게 나왔습니다. 처음 이용해봤는데 과정이 너무 매끄러워서 놀랐어요. 주변에 적극 추천하고 있습니다!", date: "2025.09" },
];

const deviceLabels: Record<string, string> = {
    phone: '스마트폰',
    tablet: '태블릿',
    airpods: '에어팟',
};

const deviceIcons: Record<string, React.ReactNode> = {
    phone: <Smartphone sx={{ fontSize: 16 }} />,
    tablet: <TabletMac sx={{ fontSize: 16 }} />,
    airpods: <Headphones sx={{ fontSize: 16 }} />,
};

/* ── 카드 컴포넌트 ── */
const ReviewCard: React.FC<{ review: Review }> = ({ review }) => (
    <Box
        sx={{
            width: { xs: 280, sm: 340 },
            minWidth: { xs: 280, sm: 340 },
            flexShrink: 0,
            background: '#fff',
            borderRadius: 3,
            border: '1px solid rgba(0,0,0,0.06)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            mx: 1.25,
            transition: 'all 0.3s cubic-bezier(0.4,0,0.2,1)',
            '&:hover': {
                borderColor: 'rgba(59,130,246,0.2)',
                boxShadow: '0 16px 48px rgba(59,130,246,0.1)',
                transform: 'translateY(-6px)',
            },
        }}
    >
        {/* 기기 정보 헤더 */}
        <Box sx={{ px: 2.5, pt: 2.5, pb: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                {/* 카테고리 뱃지 */}
                <Box sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                    px: 1.2,
                    py: 0.3,
                    borderRadius: 50,
                    background: 'rgba(59,130,246,0.06)',
                    border: '1px solid rgba(59,130,246,0.1)',
                }}>
                    {deviceIcons[review.deviceType]}
                    <Typography sx={{ fontSize: '0.68rem', fontWeight: 600, color: '#3b82f6' }}>
                        {deviceLabels[review.deviceType]}
                    </Typography>
                </Box>
                <Typography sx={{ fontSize: '0.68rem', color: '#cbd5e1', ml: 'auto' }}>
                    {review.date}
                </Typography>
            </Box>

            <Typography fontWeight={700} sx={{
                fontSize: '0.9rem',
                color: '#0f172a',
                lineHeight: 1.4,
                mb: 1,
                wordBreak: 'keep-all',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}>
                {review.device}
            </Typography>

            <Rating
                value={review.rating}
                readOnly
                size="small"
                sx={{
                    '& .MuiRating-iconFilled': {
                        color: '#f59e0b',
                        filter: 'drop-shadow(0 0 3px rgba(245,158,11,0.3))',
                    },
                    '& .MuiRating-icon': { fontSize: '1rem' },
                }}
            />
        </Box>

        {/* 리뷰 본문 */}
        <Box sx={{ px: 2.5, pb: 2.5, flex: 1 }}>
            <FormatQuote sx={{
                fontSize: 20,
                color: 'rgba(59,130,246,0.12)',
                transform: 'rotate(180deg)',
                display: 'block',
                mb: 0.5,
            }} />
            <Typography sx={{
                fontSize: '0.82rem',
                color: '#475569',
                lineHeight: 1.8,
                display: '-webkit-box',
                WebkitLineClamp: 4,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
            }}>
                {review.text}
            </Typography>
        </Box>

        {/* 하단 */}
        <Box sx={{
            px: 2.5,
            py: 1.5,
            borderTop: '1px dashed rgba(0,0,0,0.05)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: '#fafbfc',
        }}>
            <Typography sx={{ fontSize: '0.76rem', color: '#94a3b8', fontWeight: 500 }}>
                {review.name}
            </Typography>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.3,
            }}>
                <Star sx={{ fontSize: 12, color: '#f59e0b' }} />
                <Typography sx={{ fontSize: '0.72rem', color: '#f59e0b', fontWeight: 700 }}>
                    {review.rating}.0
                </Typography>
            </Box>
        </Box>
    </Box>
);

/* ── 메인 섹션 ── */
const ReviewSection: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [allReviews, setAllReviews] = useState<Review[]>(defaultReviews);
    const sectionRef = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    // Firestore에서 승인된 리뷰 로드
    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const q = query(
                    collection(db, "reviews"),
                    where("approved", "==", true),
                    orderBy("createdAt", "desc")
                );
                const snapshot = await getDocs(q);
                if (!snapshot.empty) {
                    const firestoreReviews: Review[] = snapshot.docs.map(doc => {
                        const d = doc.data();
                        const createdAt = d.createdAt?.toDate?.();
                        return {
                            id: doc.id,
                            name: d.name || '',
                            device: d.device || '',
                            deviceType: d.deviceType || 'phone',
                            rating: d.rating || 5,
                            text: d.text || '',
                            date: createdAt
                                ? `${createdAt.getFullYear()}.${String(createdAt.getMonth() + 1).padStart(2, '0')}`
                                : '',
                        };
                    });
                    setAllReviews([...firestoreReviews, ...defaultReviews]);
                }
            } catch {
                // Firestore 실패 시 기본 리뷰 유지
            }
        };
        fetchReviews();
    }, []);

    // 스크롤 진입 감지
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
            { threshold: 0.15 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    const avgRating = (allReviews.reduce((sum, r) => sum + r.rating, 0) / allReviews.length).toFixed(1);

    // 마키 카드 2세트 복제
    const marqueeItems = [...allReviews, ...allReviews];
    const cardWidth = isMobile ? 300 : 360; // 카드 너비 + 양쪽 마진
    const totalWidth = allReviews.length * cardWidth;
    const duration = allReviews.length * 3; // 초

    return (
        <Box
            ref={sectionRef}
            sx={{
                py: { xs: 4, md: 10 },
                background: '#f8fafc',
                overflow: 'hidden',
                position: 'relative',
                // 진입 애니메이션
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
                transition: 'opacity 0.8s cubic-bezier(0.4,0,0.2,1), transform 0.8s cubic-bezier(0.4,0,0.2,1)',
            }}
        >
            {/* ── 헤더 영역 ── */}
            <Box sx={{ maxWidth: { xs: '100%', md: '50%' }, mx: 'auto', px: { xs: 2, md: 0 }, mb: { xs: 2, md: 5 } }}>
                <Box sx={{
                    opacity: isVisible ? 1 : 0,
                    transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'all 0.8s cubic-bezier(0.4,0,0.2,1) 0.2s',
                }}>
                    <Typography fontWeight={800} sx={{
                        fontSize: { xs: '1.2rem', md: '1.8rem' },
                        color: '#0f172a',
                        mb: 0.5,
                    }}>
                        기기 실거래 리뷰
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        opacity: isVisible ? 1 : 0,
                        transition: 'opacity 0.8s ease 0.5s',
                    }}>
                        <Rating value={Number(avgRating)} readOnly precision={0.1} size="small" sx={{ '& .MuiRating-iconFilled': { color: '#f59e0b' } }} />
                        <Typography sx={{ fontSize: '0.85rem', color: '#64748b' }}>
                            {avgRating} (3,408개 리뷰)
                        </Typography>
                    </Box>
                </Box>

                {/* 구분선 애니메이션 */}
                <Box sx={{
                    mt: 2.5,
                    height: '1px',
                    background: 'linear-gradient(90deg, #3b82f6, rgba(59,130,246,0.1))',
                    transformOrigin: 'left',
                    transform: isVisible ? 'scaleX(1)' : 'scaleX(0)',
                    transition: 'transform 1s cubic-bezier(0.4,0,0.2,1) 0.4s',
                }} />
            </Box>

            {/* ── 마키 트랙 ── */}
            <Box sx={{
                position: 'relative',
                maxWidth: { xs: '100%', md: '50%' },
                mx: 'auto',
                overflow: 'hidden',
                // 좌우 페이드 마스크
                maskImage: 'linear-gradient(90deg, transparent 0%, black 6%, black 94%, transparent 100%)',
                WebkitMaskImage: 'linear-gradient(90deg, transparent 0%, black 6%, black 94%, transparent 100%)',
                // 진입 애니메이션
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.8s ease 0.6s',
            }}>
                <Box
                    sx={{
                        display: 'flex',
                        width: 'fit-content',
                        animation: `marquee ${duration}s linear infinite`,
                        '&:hover': {
                            animationPlayState: 'paused',
                        },
                        '@keyframes marquee': {
                            '0%': { transform: 'translateX(0)' },
                            '100%': { transform: `translateX(-${totalWidth}px)` },
                        },
                        py: 1,
                    }}
                >
                    {marqueeItems.map((review, idx) => (
                        <ReviewCard key={`${review.id}-${idx}`} review={review} />
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default ReviewSection;
